import { withStyles } from 'tss-react/mui'
import { LinearProgress } from '@mui/material'

const ColorLinearProgress = withStyles(LinearProgress, (theme) => ({
  root: {
    width: '100%',
    height: 10,
    borderRadius: 20,
    backgroundColor: theme.palette.info.main,
    '@media (min-width: 376px)': {
      width: '100%',
    },
  },
  bar: {
    borderRadius: 20,
    backgroundColor: theme.palette.primary.main,
    ...theme.brand.assets.layout?.loadingBarOverwrite,
  },
}))

export default ColorLinearProgress
